

import { DEBUG } from "../../../config";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import React, { useEffect, FC, memo, useMemo, useState, useRef } from "../../../lib/teact/teact";
import Avatar from "../../common/Avatar";

import FloatingActionButton from "../../ui/FloatingActionButton";
import InfiniteScroll from "../../ui/InfiniteScroll";
import ListItem from "../../ui/ListItem";
import Loading from "../../ui/Loading";

import { LotScreenSettings } from "../config/uiconfig";

import { fetchContact, fetchContactExtraInfo, removeCurrentContact, updateCurrentSelectedContact, updateContactOrder, filterContactByType } from "../redux/contactsSlice";
import store from "../store";
import LotContactItem from "./LotContactItem";

import _ from 'lodash'
import AddContact from "./addContact";
import { updateLastScreen } from "../redux/loginSlice";
import ConfirmDialog from "../../ui/ConfirmDialog";
import Snackbar from "../ui/snackbar";
import { ContactsApi } from "../restapi/contactsApi";
import { debounce } from "../utils/common";
import Parser from "../restapi/parser";
import worker from "../setupWorker";
import { sleep } from "../../../lib/gramjs/Helpers";
import { Dexiedb } from "../db/Dexiedb";


export type OwnProps = {
    isActive: boolean;
    filter: string;
    contactIds: string[];
    onChangeScreen: (screen: LotScreenSettings) => void;
    menuAction: string;
    // contactIds: string[];

};

type StateProps = {
    //onChangeScreen,
    // contactIds?: string[];
};
const LotContactList: FC<OwnProps & StateProps> = ({
    isActive,
    filter,
    contactIds,
    onChangeScreen,
    menuAction,
    // contactIds,


}) => {

    const containerRef = useRef<HTMLDivElement>()
    const contactSlice = (store: any) => {
        return store.getState().contact; // thuoc tinh name trong createSlice
    }
    const contactMap = store.getState().contact.contactArr;
    //lấy tham chiếu vào contact trong reducer
    //const [contactIds, setContactIds] = useState(contactSlice(store).contactIdLists);
    const lastId = store.getState().contact.lastContactElementId;
    const [showAddContact, setShowAddContact] = useState(false);
    const [showCopyContact, setShowCopyContact] = useState(false);
    const [showDeleteContact, setShowDeleteContact] = useState(false);
    const [state, setState] = useState({
        showSnackbar: false,
        snackbarMessage: "",
    })
    const onDataStorechanged = () => {
        // const ids = store.getState().contact.contactIdLists
        // const map = store.getState().contact.contactArr
        // if (!_.isEqual(contactIds, ids) /* || !_.isEqual(contactMap, map) */) {
        //     //console.log(`Dữ liệu ids thay đổi, cần render lại UI ${ids}`)
        //     setContactIds(ids)
        // }
    }
    useEffect(() => {
        const unSubscribe = store.subscribe(onDataStorechanged)
        return unSubscribe
    }, [])
    // lần đầu render, nạp dữ liệu danh bạ lên
    useEffect(() => {
        store.dispatch(fetchContact())
        const payload = { ngay: store.getState().global.workDate }
        store.dispatch(fetchContactExtraInfo(payload))
        const scroll = debounce(() => {
            const e = document.getElementById("LeftMainHeader")
            e?.scrollIntoView()
        }, 500)
        scroll()
    }, [])
    // Lưu lại màn hình prev
    useEffect(() => {
        store.dispatch(updateLastScreen(LotScreenSettings.CONTACT_LIST_SCREEN))

    }, [])
    useEffect(() => {
        if (menuAction == "AllContacts") {
            console.log("AllContacts")
            store.dispatch(filterContactByType({ filterByType: "AllContacts" }))
        } else if (menuAction == "CustomerContacts") {
            console.log("CustomerContacts")
            store.dispatch(filterContactByType({ filterByType: "CustomerContacts" }))
        } else if (menuAction == "SupplierContacts") {
            console.log("SupplierContacts")
            store.dispatch(filterContactByType({ filterByType: "SupplierContacts" }))
        }
    }, [menuAction])
    const listIds = contactIds
    // ? undefined
    // : Array.from({ length: contactIds.length }, (idx, i) => i);

    // const listIds = useMemo(() => {
    //     if (!contactIds) {
    //         return undefined;
    //     }
    //     let result: any[] = []
    //     contactIds.map((item: any, index: number) => {
    //         result.push(index)
    //     }
    //     )
    //     return result
    // }, [contactIds, filter, showAddContact]);

    let oldOffsetId: undefined | number | string;
    //view port được lưu lại để quay về
    //if (store.getState().contact.viewportIds.length > 0) {
    const oldIndex = store.getState().contact.lastContactElementId.split(":")[1]
    oldOffsetId = listIds?.indexOf(Number(oldIndex));

    //}
    const [viewportIds, getMore] = useInfiniteScroll(undefined, listIds, Boolean(filter), 20, oldOffsetId);
    function scrollToPrevContactItem() {
        //dùng cơ chế này để nhớ lại phần tử cũ, khi quay về thì render lại cho đúng vị trí xuất phát
        if (DEBUG)
            console.log("Sau khi vẽ lần đầu tiên")
        /*  let idBack15 = "contact-item" + viewportIds[15]
        let elBack15 = document.getElementById(idBack15)
        if (elBack15) {
         (elBack15 as HTMLElement).scrollIntoView({ behavior: 'auto' });
        } */
        let lastEl = document.getElementById(lastId)
        if (lastEl) {
            (lastEl as HTMLElement).scrollIntoView({ behavior: 'auto' }); //auto, smooth


            console.log(`scroll to old item:${lastId}`)

        } else if (!lastId.endsWith(":0")) { // phần tử cuối của 1 trang, phần sau của trang ko được load
            // nên ko tồn tại trong dom
            lastEl = document.getElementById("contact-item:" + viewportIds![viewportIds!.length - 1])
            if (lastEl) {
                (lastEl as HTMLElement).scrollIntoView({ behavior: 'auto' }); //auto, smooth
            }
        }
    }
    useEffect(() => {
        scrollToPrevContactItem()
    }, [contactIds, filter])
    const handleDanhBaClick = (id: string, domId: string) => {
        console.log(`Danh bạ clicked: index:${domId}}`)
        const div = document.getElementById(domId) as HTMLDivElement
        const itemRect = div.getBoundingClientRect();
        const container = containerRef.current;
        if (!container) {
            return;
        }
        store.dispatch(updateCurrentSelectedContact({
            id,
            scrollTop: container.scrollTop - itemRect.top,
        }))
    }
    function onAddContactClose() {
        setShowAddContact(false)

    }
    function onAddContactConfirm() {
        setShowAddContact(false)
        onChangeScreen(LotScreenSettings.EDIT_CONTACT_SCREEN)

    }
    function onCopyContactClose() {
        setShowCopyContact(false)
    }
    function onCopyContactConfirm() {
        setShowCopyContact(false)

    }
    const moveContact = (contactId: string, delta: -1 | 1) => {
        // contactIds là prop (nguồn thứ tự)
        if (!contactIds || contactIds.length < 2) return;

        const from = contactIds.indexOf(contactId);
        if (from < 0) return;

        const to = from + delta;
        if (to < 0 || to >= contactIds.length) return;

        const next = contactIds.slice() as string[];
        [next[from], next[to]] = [next[to], next[from]];

        // 1) cập nhật redux ( action/reducer)
        
        //const contactArr = store.getState().contact.contactArr;
        const ct2 = contactMap[Number(next[from]) as number] as any;
        const ct1 = contactMap[Number(next[to]) as number] as any;
        const order = [{ contactId: ct1.contactId, newSortOrder: ct2.sortOrder }, { contactId: ct2.contactId, newSortOrder: ct1.sortOrder }]
        store.dispatch(updateContactOrder({ order: next , ct1:ct1, ct2:ct2 }));
        updateContactOrderApi(order)
        console.log('', ct1.name , '<-> ' , ct2.name,"order",ct1.sortOrder,"to",ct2.sortOrder)
        //console.log('moveContact', order)
    };
  
    const updateContactOrderApi = async (order: any) => {
        const result = await ContactsApi.updateContactOrder({ order: order })
        //console.log('updateContactOrder', result)
    }
    return (
        <>
            <InfiniteScroll style="height:calc(100% - var(--header-height))"
                items={viewportIds} onLoadMore={getMore} className="chat-list custom-scroll"
                // currentAnchor={currentAnchor}
                ref={containerRef}
            >
                {viewportIds?.length ? (
                    viewportIds.map((id, index) => {
                        const curContact = contactMap[id]
                        const domId = "contact-item:" + id
                        return (
                            <div id={domId} key={id} className="list-item-contact">
                                <div className="display-data">
                                    <ListItem
                                        leftElement={(
                                            <Avatar
                                                //photo={notPersonalPhoto}
                                                noPersonalPhoto
                                                //peer={user}
                                                text={curContact ? curContact.name : ""}
                                                size="large"
                                                className="personal-photo"
                                            />
                                        )}
                                        className="chat-item-clickable"
                                        // eslint-disable-next-line react/jsx-no-bind
                                        ripple
                                        onClick={() => {
                                            handleDanhBaClick(id, domId)
                                            onChangeScreen(LotScreenSettings.TOTAL_REPORT_BY_CONTACT_SCREEN)

                                        }}
                                        contextActions={[
                                            {
                                                handler: () => {
                                                    handleDanhBaClick(id, domId)
                                                    onChangeScreen(LotScreenSettings.TOTAL_REPORT_BY_CONTACT_SCREEN)
                                                },
                                                title: 'Nhập tin nhắn',
                                                icon: 'readchats',
                                            },
                                            {
                                                handler: () => {
                                                    handleDanhBaClick(id, domId)
                                                    onChangeScreen(LotScreenSettings.EDIT_CONTACT_SCREEN)
                                                },
                                                title: 'Chỉnh sửa thông tin',
                                                icon: 'edit',
                                            },
                                            {
                                                handler: () => {
                                                    handleDanhBaClick(id, domId)
                                                    setShowCopyContact(true)
                                                    console.log('Copy danh bạ')
                                                },
                                                title: 'Copy sang số mới',
                                                icon: 'copy',
                                            },
                                            {
                                                handler: () => {
                                                    handleDanhBaClick(id, domId)
                                                    setShowDeleteContact(true)
                                                },
                                                title: 'Xoá danh bạ này',
                                                icon: 'delete',
                                            },
                                            {
                                                handler: () => {
                                                    handleDanhBaClick(id, domId)
                                                    moveContact(id, -1) // lên
                                                },
                                                title: 'Di chuyển lên',
                                                icon: 'move-caption-up',
                                            },
                                            {
                                                handler: () => {
                                                    handleDanhBaClick(id, domId)
                                                    moveContact(id, +1) // xuống
                                                },
                                                title: 'Di chuyển xuống',
                                                icon: 'move-caption-down',
                                            },


                                        ]}


                                    >
                                        {curContact && <LotContactItem curContact={curContact} />
                                        }
                                    </ListItem>
                                </div>

                            </div>
                        )
                    }))
                    : viewportIds && !viewportIds.length ? (
                        <p className="no-results" key="no-results" dir="auto">
                            {filter.length ? 'Không tìm thấy danh bạ thoả mãn.' : 'Bạn chưa có khách hàng nào, hãy tạo mới.'}
                        </p>
                    ) : (
                        <Loading key="loading" />
                    )}
                <FloatingActionButton
                    key="create-new-contact"
                    isShown
                    onClick={() => {
                        setShowAddContact(true)
                    }}

                //ariaLabel={lang('CreateNewContact')}
                >
                    <i className="icon icon-add-user-filled" />
                </FloatingActionButton>

            </InfiniteScroll>
            <AddContact isOpen={showAddContact}
                isAddNew
                title="Thêm danh bạ mới"
                confirmLabel="Thêm mới"
                onClose={onAddContactClose}
                confirmHandler={onAddContactConfirm} />
            <AddContact isOpen={showCopyContact}
                isAddNew={false}
                title="Copy danh bạ"
                confirmLabel="Copy"
                onClose={onCopyContactClose}
                confirmHandler={onCopyContactConfirm}
                onChangeScreen={onChangeScreen}
            />
            <ConfirmDialog
                confirmHandler={async () => {
                    setShowDeleteContact(false)
                    const id = store!.getState().contact!.currentContact!.contactId
                    const payload = { contactId: id }
                    const data = await ContactsApi.getMessageIdsByContact(payload)
                    const msgIds = data.data
                    let i = 0
                    const len = msgIds ? msgIds.length : 0
                    if (msgIds)
                        for (let id of msgIds) {
                            i++
                            await Parser.deleteMessage(id)
                            worker.postMessage({ type: 'showsnackbar', data: `Đang xoá dữ liệu vui lòng chờ ${i}/${len}` })
                            await sleep(100)
                        }
                    worker.postMessage({ type: 'showsnackbar', data: `Đang xoá dữ liệu liên quan, vui lòng chờ ` })
                    ContactsApi.deleteContact(payload).then(result => {
                        worker.postMessage({ type: 'showsnackbar', data: result.responseText })
                        Dexiedb.instance.contacts.delete(id)
                        store.dispatch(removeCurrentContact(undefined))
                    })
                }}
                confirmLabel="Xoá"
                title="Xoá danh bạ"
                text="Xoá danh bạ này sẽ xoá sạch toàn bộ số liệu phát sinh liên quan, bạn hãy cẩn trọng!"
                isOpen={showDeleteContact}
                onClose={() => { setShowDeleteContact(false) }}
            />
            <Snackbar
                isOpen={state.showSnackbar}
                message={state.snackbarMessage}
                onClose={() => { setState(prev => ({ ...prev, showSnackbar: false })) }}
                triggerTime={JSON.stringify(new Date())}
            />
        </>
    )
}
export default memo(LotContactList)

